import { create } from 'zustand';

const PERSIST_KEY = 'attendance_currentWorkspaceId';

export interface Workspace {
    _id: string;
    name: string;
    slug: string;
    ownerId: string;
    enabledPlugins?: string[];
    /** Diisi GET /workspaces (enrichWithOwner) — untuk "hubungi {owner}". */
    owner?: { name?: string | null; email?: string | null } | null;
}

/**
 * Status load daftar workspace — supaya halaman bisa bedakan "masih memuat"
 * vs "gagal memuat" (server sibuk) vs "memang tidak punya workspace". Dulu
 * kegagalan ditelan → HomePage macet di "Memuat…" selamanya.
 */
export type WorkspaceLoadStatus = 'idle' | 'loading' | 'ready' | 'error';

interface WorkspaceState {
    workspaces: Workspace[];
    currentWorkspace: Workspace | null;
    loadStatus: WorkspaceLoadStatus;
    setLoadStatus: (status: WorkspaceLoadStatus) => void;
    setWorkspaces: (list: Workspace[]) => void;
    setCurrent: (ws: Workspace | null) => void;
    /** Perbarui satu workspace di daftar + current (mis. setelah Absensi diaktifkan). */
    patchWorkspace: (id: string, patch: Partial<Workspace>) => void;
    getPersistedId: () => string | null;
}

function loadId(): string | null {
    try { return localStorage.getItem(PERSIST_KEY); } catch { return null; }
}
function saveId(id: string | null) {
    try {
        if (id) localStorage.setItem(PERSIST_KEY, id);
        else localStorage.removeItem(PERSIST_KEY);
    } catch {}
}

export const useWorkspaceStore = create<WorkspaceState>((set, get) => ({
    workspaces: [],
    currentWorkspace: null,
    loadStatus: 'idle',
    setLoadStatus: (loadStatus) => set({ loadStatus }),
    setWorkspaces: (workspaces) => set({ workspaces }),
    setCurrent: (currentWorkspace) => {
        saveId(currentWorkspace?._id || null);
        set({ currentWorkspace });
    },
    patchWorkspace: (id, patch) => {
        const { workspaces, currentWorkspace } = get();
        set({
            workspaces: workspaces.map((w) => (w._id === id ? { ...w, ...patch } : w)),
            currentWorkspace: currentWorkspace?._id === id ? { ...currentWorkspace, ...patch } : currentWorkspace,
        });
    },
    getPersistedId: () => loadId(),
}));
